import { MainCard } from '@components/BaseStyles';
import { styled } from '@mui/system';

export const UploadImageContainer = styled(MainCard)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '16px',
  gap: '16px',
});
